mutation updateUserPreferences($input: PreferencesInput!) {
  base {
    updatePreferences(input: $input) {
      theme
      locale
      cubeContext {
        workspaceId
        scenarioId
        originId
        __typename
      }
    }
    __typename
  }
}
